import CardsViewProvider from "./CardsView.provider"
import CardsViewList from "./CardsViewList"

export default {
    Provider: CardsViewProvider,
    List: CardsViewList,
}
